<button mat-menu-item [disabled]="!editingEnabled" (click)="editingEnabledChanged.emit(false)">
  <mat-icon class="editor-mode">visibility</mat-icon>
  <span>{{ 'button.view_mode' | translate }}</span>
</button>
<button mat-menu-item [disabled]="editingEnabled" (click)="editingEnabledChanged.emit(true)">
  <mat-icon class="editor-mode">edit</mat-icon>
  <span>{{ 'button.edit_mode' | translate }}</span>
</button>
